import { SegmentedControl, Separator, StaticMenuLayout, VText } from '@vake/ui-kit';
import { FC } from 'react';
import ReactDatePicker from 'react-datepicker';
import { Link } from 'react-router-dom';
import { Filters, Props as FiltersProps } from './filters';
type CalendarProps = {
    subscriptionStart: Date;
    startDate: Date | null;
    endDate: Date | null;
    setStartDate: (date: Date | null) => void;
    setEndDate: (date: Date | null) => void;
};
type Props = {
    reportName: string;
    selected: number;
    setSelected: (value: number) => void;
    filtersProps: FiltersProps;
    calendarProps: CalendarProps;
};
export const LeftBar: FC<Props> = ({ reportName, selected, setSelected, filtersProps, calendarProps }) => {
    const onChange = (dates: [Date | null, Date | null]) => {
        const [start, end] = dates;
        start?.setHours(0, 0);
        end?.setHours(23, 59);
        calendarProps.setStartDate(start);
        calendarProps.setEndDate(end);
    };
    const tomorrow = new Date();
    tomorrow.setDate(new Date().getDate() + 1);
    tomorrow.setHours(0, 0);
    const Menu = () => {
        return (
            <div className="flex flex-col gap-2">
                <Link to={'/'}>
                    <VText variant="B2">Go to home</VText>
                </Link>
                <Separator opaque />
                <Link to={'/overwatch-reports'}>
                    <VText variant="B2">Go to all reports</VText>
                </Link>
            </div>
        );
    };
    const TheRest = () => {
        return (
            <div className="flex flex-col">
                <SegmentedControl selected={selected} setSelected={setSelected}>
                    <SegmentedControl.Item label="Date range">
                        <div className="flex pt-4 px-4">
                            <VText>Set the date range by clicking twice on one day or clicking on two days</VText>
                        </div>
                        <div className="flex justify-center pt-4">
                            <ReactDatePicker
                                selected={calendarProps.startDate}
                                startDate={calendarProps.startDate}
                                endDate={calendarProps.endDate}
                                onChange={onChange}
                                minDate={calendarProps.subscriptionStart}
                                maxDate={tomorrow} // Add more dates when we have scraper
                                dateFormat="yyyy-mm-dd"
                                calendarStartDay={1}
                                showYearDropdown
                                selectsRange
                                inline
                            />
                        </div>
                    </SegmentedControl.Item>
                    <SegmentedControl.Item label="Filters">
                        <Filters {...filtersProps} />
                    </SegmentedControl.Item>
                    {/* <SegmentedControl.Item label="Settings">
                        <div className="pt-4 flex justify-center">
                            <Button
                                size="small"
                                variant="neutral"
                                iconBefore={<Download size={16} />}
                                text="Download full dataset as CSV"
                                onClick={() => {}}
                            />
                        </div>
                    </SegmentedControl.Item> */}
                </SegmentedControl>
            </div>
        );
    };
    return <StaticMenuLayout title={reportName} menuChildren={<Menu />} children={<TheRest />} />;
};
